// import BeforeAfter from './before-after'
import BeforeAfter2 from './before-after2'
import BookingForm from './booking-form'
import DoubleText from './double-text'
import FullscreenMedia from './fullscreen-media'
import Grid from './grid'
import GridServices from './grid-services'
import GridTeam from './grid-team'
import Hero from './hero'
import HomeClinic from './home-clinic'
import HomeDr from './home-dr'
import HomeHero from './home-hero'
import HomeHuman from './home-human'
import ImageText from './image-text'
import ImageTextCarousel from './image-text-carousel'
import SingleText from './single-text'
import Spacer from './spacer'

export const sectionsMap: any = {
  before_after: BeforeAfter2,
  double_text: DoubleText,
  booking_form: BookingForm,
  grid: Grid,
  grid_services: GridServices,
  grid_team: GridTeam,
  hero: Hero,
  home_dr: HomeDr, // TODO
  home_hero: HomeHero, // TODO
  home_humans: HomeHuman, // TODO
  home_clinic: HomeClinic, // TODO
  image_text: ImageText,
  image_text_carousel: ImageTextCarousel,
  media: FullscreenMedia,
  single_text: SingleText,
  spacer: Spacer
}
